<template>
  <button
    :title="$t('sharing.messenger')"
    type="button"
    class="facebook-messenger"
    @click="share"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-full w-full"
      fill="none"
      viewBox="0 0 30 30"
    >
      <rect
        width="29.5"
        height="29.5"
        x=".3"
        y=".3"
        stroke="#fff"
        stroke-width=".5"
        rx="14.8"
      />
      <path
        fill="#fff"
        d="M9.2 20.9v3.3l3-1.8c1 .3 1.9.4 2.8.4 5 0 9.2-3.8 9.2-8.5S20 5.8 15 5.8c-5 0-9.2 3.8-9.2 8.5 0 2.7 1.3 5 3.4 6.6z"
      />
      <path d="M14 11.7l-5.5 5.7 5-2.7 2.5 2.7 5.4-5.7-4.9 2.6-2.6-2.6z" />
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    encodedUrl() {
      return encodeURI(this.url)
    },
  },
  methods: {
    share() {
      this.$store.dispatch('tracking/trackGeneric', {
        category: 'sharing',
        action: 'facebook messenger',
        label: this.text,
      })
      let url =
        `https://www.facebook.com/dialog/send?display=popup&app_id=` +
        `${this.$config.fbAppId}&link=${this.url}&redirect_uri=${this.encodedUrl}`
      // we assume that if it's a mobile device and the user wants to share to fb-messenger the app is isntalled.
      if (/android|iPad|iPhone|iPod/i.test(navigator.userAgent)) {
        url =
          `fb-messenger://share/?app_id=` +
          `${this.$config.fbAppId}&link=${this.encodedUrl}`
      }
      window.open(url, '_blank', 'width=500,height=400')
    },
  },
}
</script>
